import { DateTime } from 'luxon';

export type TimeWindowInput = {
  date: string;          // 'YYYY-MM-DD'
  pickup_time: string;   // 'HH:MM' (may be empty for will-call)
  is_will_call: boolean;
};

export type TimeWindow = {
  rangeStart: string;    // ISO
  rangeEnd: string;      // ISO
};

const SCHEDULED_WINDOW_MINUTES = 15;

export function buildLegTimeWindow(
  input: TimeWindowInput,
  orgZone: string
): TimeWindow {
  if (input.is_will_call) {
    const dayStart = DateTime.fromISO(input.date, { zone: orgZone }).startOf(
      'day'
    );
    const dayEnd = DateTime.fromISO(input.date, { zone: orgZone }).endOf('day');
    return { rangeStart: dayStart.toISO()!, rangeEnd: dayEnd.toISO()! };
  }

  const center = DateTime.fromISO(`${input.date}T${input.pickup_time}`, {
    zone: orgZone,
  });
  return {
    rangeStart: center.minus({ minutes: SCHEDULED_WINDOW_MINUTES }).toISO()!,
    rangeEnd: center.plus({ minutes: SCHEDULED_WINDOW_MINUTES }).toISO()!,
  };
}
